import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punedarshancab() {



    const cardData = {

        keyword: "Pune Darshan Cab",

        headingDescription:
            "Rising Cab Service offers a comfortable, affordable, and well-planned Pune Darshan Cab service for tourists, families, corporate groups, pilgrims, and local travelers who wish to explore the cultural and historical beauty of Pune. Our Pune sightseeing taxi service is designed to cover the city's most popular attractions with flexible itineraries and professional drivers who are familiar with local routes and tourist destinations. Whether you want a half-day city tour or a full-day Pune Darshan package, we provide clean and well-maintained Sedan, SUV, Innova Crysta, Tempo Traveller, Urbania, and luxury vehicles to match your travel requirements. Our service includes hotel pickups, airport transfers, railway station pickups, family outings, educational tours, and customized sightseeing packages. Rising Cab Service ensures punctual pickups, transparent pricing, experienced chauffeurs, and a safe travel experience for every passenger. From historical monuments and spiritual temples to beautiful gardens and museums, our Pune Darshan Cab service helps you discover the city's rich heritage and modern attractions comfortably. Available 24x7, we make sightseeing convenient and memorable for solo travelers, couples, families, and large groups visiting the cultural capital of Maharashtra.",

        topPlaces: [
            {
                title: "Shaniwar Wada",
                description:
                    "Shaniwar Wada is Pune's most iconic historical monument and was the grand seat of the Peshwa rulers of the Maratha Empire. Built in 1732, the fort showcases impressive gateways, massive stone walls, beautiful gardens, and remains of royal palaces. Visitors can explore its rich history while enjoying the evening light and sound show that narrates the glorious past of the Marathas."
            },
            {
                title: "Aga Khan Palace",
                description:
                    "Aga Khan Palace is one of India's important heritage sites and played a significant role during the freedom movement. Built in 1892, it served as a prison for Mahatma Gandhi and Kasturba Gandhi during the Quit India Movement. Surrounded by beautiful gardens, the palace houses a museum, historical artifacts, and memorials dedicated to India's independence struggle."
            },
            {
                title: "Dagadusheth Halwai Ganpati Temple",
                description:
                    "Dagadusheth Halwai Ganpati Temple is among the most famous Lord Ganesha temples in India and attracts thousands of devotees every day. The beautifully decorated idol adorned with gold ornaments creates a divine atmosphere. During Ganesh Chaturthi, the temple becomes the center of grand celebrations and cultural activities in Pune."
            },
            {
                title: "Sinhagad Fort",
                description:
                    "Sinhagad Fort is a historic hill fort located on the Sahyadri ranges and is famous for the legendary battle fought by Tanaji Malusare. The fort offers breathtaking views of the surrounding valleys and mountains. It is a favorite destination for trekkers, photographers, and history lovers who enjoy exploring ancient ruins and traditional Maharashtrian food."
            },
            {
                title: "Pataleshwar Cave Temple",
                description:
                    "Pataleshwar Cave Temple is an ancient rock-cut temple dedicated to Lord Shiva and dates back to the 8th century. Carved from a single basalt rock, the temple features impressive pillars, sculptures, and a peaceful atmosphere in the heart of Pune city. It is an excellent destination for history enthusiasts and spiritual seekers."
            },
            {
                title: "Raja Dinkar Kelkar Museum",
                description:
                    "Raja Dinkar Kelkar Museum is one of Pune's most fascinating museums, displaying an extensive collection of Indian art, antiques, musical instruments, traditional weapons, textiles, and household artifacts. The museum provides visitors with a glimpse into India's rich cultural heritage and craftsmanship spanning several centuries."
            },
            {
                title: "Saras Baug",
                description:
                    "Saras Baug is a beautiful garden and recreational spot in Pune known for its lush greenery and the famous Siddhivinayak Temple located at its center. Families and tourists visit the park to relax, enjoy peaceful walks, and seek blessings at the temple. The well-maintained gardens make it an ideal location for evening outings."
            },
            {
                title: "Parvati Hill Temple",
                description:
                    "Parvati Hill is one of Pune's oldest heritage sites and offers spectacular panoramic views of the city. The hill houses ancient temples dedicated to Lord Shiva, Goddess Parvati, Lord Vishnu, and Lord Kartikeya. Climbing the historic stone steps rewards visitors with peaceful surroundings and a glimpse into Pune's spiritual and architectural heritage."
            },
            {
                title: "Khadakwasla Dam",
                description:
                    "Khadakwasla Dam is a popular picnic destination near Pune, known for its scenic reservoir and peaceful surroundings. The location is especially attractive during the monsoon season when the water levels rise and the landscape becomes lush and green. Visitors enjoy relaxing by the water, photography, and local street food."
            },
            {
                title: "Pune Okayama Friendship Garden",
                description:
                    "Pune Okayama Friendship Garden, also known as Pu La Deshpande Garden, is one of the largest Japanese-style gardens in Asia. Inspired by the famous Korakuen Garden of Japan, it features beautifully landscaped lawns, flowing streams, bridges, waterfalls, and colorful flowers. The garden provides a calm and refreshing environment for nature lovers and families."
            }
        ],



        services: [
            {
                name: "Pune Darshan Cab Booking",
                description:
                    "Rising Cab Service offers reliable Pune Darshan Cab Booking for tourists, families, business travelers, and local residents who want to explore the city's famous attractions comfortably. Our well-maintained cabs and experienced drivers ensure a smooth sightseeing experience covering historical monuments, temples, gardens, museums, and popular tourist destinations. Customers can book full-day or customized Pune Darshan packages with flexible timings and affordable pricing."
            },
            {
                name: "Pune Darshan Cab Service",
                description:
                    "Our Pune Darshan Cab Service is designed to provide convenient and hassle-free local sightseeing across Pune's major landmarks. Whether you wish to visit Shaniwar Wada, Aga Khan Palace, Dagdusheth Ganpati Temple, Saras Baug, Sinhagad Fort, or other attractions, Rising Cab Service offers comfortable vehicles, professional drivers, and customized tour plans for individuals, families, and groups."
            },
            {
                name: "Pune City Tour Cab",
                description:
                    "Rising Cab Service provides Pune City Tour Cab packages for one-day and full-day sightseeing trips. Our city tour service covers cultural, historical, religious, and modern attractions across Pune with flexible itineraries according to customer preferences. We offer hatchbacks, sedans, SUVs, Innova Crysta, and tempo travellers to suit every travel requirement and group size."
            },
            {
                name: "Pune Sightseeing Cab",
                description:
                    "Pune Sightseeing Cab by Rising Cab Service offers affordable and comfortable transportation for exploring the city's top tourist places and nearby attractions. Whether planning a family outing, temple visit, educational trip, or weekend excursion, our experienced drivers provide safe and timely travel while ensuring a pleasant sightseeing experience throughout the journey."
            },
            {
                name: "Pune Darshan Package Cab",
                description:
                    "Our Pune Darshan Package Cab service provides complete sightseeing solutions including local Pune attractions, temple tours, heritage sites, and customized travel plans. Customers can choose half-day, full-day, or specially designed tour packages with transparent pricing and multiple vehicle options. Rising Cab Service ensures reliable transportation, clean cabs, and professional service for an enjoyable Pune Darshan experience."
            }
        ],

        tableData: [
            ["Pune Darshan Cab Booking", "Pune Darshan Cab Service"],
            ["Pune Darshan Taxi", "Pune Darshan Taxi Service"],
            ["Pune City Tour Cab", "Pune Sightseeing Cab"],
            ["Pune Local Cab Service", "Pune Darshan Package Cab"],
            ["Pune One Day Tour Cab", "Pune Tourism Cab Service"],
            ["Pune Temple Darshan Cab", "Pune Heritage Tour Cab"],
            ["Best Pune Darshan Cab Service", "Affordable Pune Darshan Cab"],
            ["Pune Cab Booking for Sightseeing", "Pune Airport to Pune Darshan Cab"],
            ["Pune Full Day Cab Service", "Pune Local Sightseeing Taxi"],
            ["Pune Darshan Car Rental", "Pune Tourist Cab Service"]
        ],



        whychoose: [
            {
                WhyChooseheading: "Complete Pune Sightseeing Cab Service",
                WhyChoosedescription: "Rising Cab Service provides dedicated Pune Darshan cab services covering historical monuments, famous temples, gardens, museums, forts, and the city's most popular tourist attractions."
            },
            {
                WhyChooseheading: "Comfortable Vehicles for City Tours",
                WhyChoosedescription: "Our Pune Darshan fleet includes Sedan cars, Ertiga, Innova Crysta, and spacious vehicles designed to make your sightseeing journey comfortable and enjoyable."
            },
            {
                WhyChooseheading: "Well-Planned Pune Darshan Packages",
                WhyChoosedescription: "Rising Cab Service offers organized Pune Darshan packages that help travelers visit multiple attractions efficiently within their available time."
            },
            {
                WhyChooseheading: "Affordable Pune Darshan Travel",
                WhyChoosedescription: "We provide budget-friendly Pune sightseeing cab services with transparent pricing and excellent value for families, tourists, and groups."
            },
            {
                WhyChooseheading: "Experienced Local Drivers",
                WhyChoosedescription: "Our drivers have extensive knowledge of Pune's tourist attractions, routes, and travel timings, ensuring a smooth sightseeing experience."
            },
            {
                WhyChooseheading: "Flexible Pickup & Drop Locations",
                WhyChoosedescription: "Rising Cab Service offers convenient pickup and drop facilities from Pune Airport, Railway Station, hotels, homes, and major locations across Pune."
            },
            {
                WhyChooseheading: "Ideal for Families and Tourists",
                WhyChoosedescription: "Our Pune Darshan cab service is suitable for family outings, vacation travelers, senior citizens, students, and visitors exploring the city."
            },
            {
                WhyChooseheading: "Safe and Hassle-Free Travel",
                WhyChoosedescription: "We maintain high safety standards with clean vehicles, professional drivers, punctual service, and dedicated customer support throughout the trip."
            }
        ]
    };

    const faqData = [
        {
            question: "What is Pune Darshan Cab Service?",
            answer: "Pune Darshan Cab Service allows travelers to explore major tourist attractions, temples, forts, museums, and cultural landmarks in Pune using a private cab."
        },
        {
            question: "Which tourist places are covered in Pune Darshan?",
            answer: "Popular attractions include Shaniwar Wada, Aga Khan Palace, Dagdusheth Ganpati, Saras Baug, Lal Mahal, Pataleshwar Temple, Sinhagad Fort, and many more."
        },
        {
            question: "Do you provide full-day Pune Darshan packages?",
            answer: "Yes, Rising Cab Service offers full-day as well as customized Pune Darshan sightseeing packages."
        },
        {
            question: "Can I customize my Pune Darshan itinerary?",
            answer: "Yes, travelers can customize their sightseeing route based on their interests and available travel time."
        },
        {
            question: "Which vehicles are available for Pune Darshan?",
            answer: "We offer Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and larger vehicles for group sightseeing."
        },
        {
            question: "Is Pune Darshan suitable for families?",
            answer: "Yes, our Pune Darshan service is designed for families, tourists, senior citizens, students, and groups."
        },
        {
            question: "Do you provide pickup from Pune Airport?",
            answer: "Yes, pickup and drop services are available from Pune Airport, Railway Station, hotels, and residential locations."
        },
        {
            question: "How many hours are required for Pune Darshan?",
            answer: "The duration typically ranges from 6 to 10 hours depending on the places selected and sightseeing schedule."
        },
        {
            question: "Are your drivers familiar with Pune tourist attractions?",
            answer: "Yes, our experienced drivers are well acquainted with Pune's sightseeing destinations and travel routes."
        },
        {
            question: "How can I book a Pune Darshan Cab?",
            answer: "You can book your Pune Darshan Cab through phone, WhatsApp, or online booking with Rising Cab Service."
        }
    ];

    const testimonials = [
        {
            id: 1,
            name: "Mr. Sandeep More",
            feedback:
                "Our Pune city tour became memorable thanks to Rising Cab Service. The vehicle was clean, the driver was courteous, and every destination was covered comfortably.",
            rating: 5
        },
        {
            id: 2,
            name: "Mrs. Vaishali Patwardhan",
            feedback:
                "Exploring Pune's famous attractions was easy and enjoyable with Rising Cab Service. Professional service, punctual timing, and excellent travel support throughout the journey.",
            rating: 5
        }
    ];























    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];














const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune Darshan Cab Service",
  "image": "https://www.risingcabservice.com/assets/images/pune-darshan-cab.jpg",
  "description": "Book Pune Darshan Cab Service for city sightseeing, temple visits, heritage tours, and one-day Pune tours. Rising Cab Service offers affordable Pune Darshan packages with experienced drivers and comfortable vehicles.",
  "brand": {
    "@type": "Brand",
    "name": "Rising Cab Service"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹14/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.risingcabservice.com/pune-darshan-cab"
  }
};







    return (
        <div>

<Helmet>
  <title>Pune Darshan Cab Service | Pune Sightseeing Taxi | +91 9272511548</title>

  <meta
    name="description"
    content="Book Pune Darshan Cab Service for city sightseeing, temple visits, heritage tours, and one-day Pune tours. Affordable Pune Darshan taxi packages with professional drivers."
  />

  <meta
    name="keywords"
    content="Pune darshan cab booking, Pune darshan cab service, Pune darshan taxi, Pune darshan taxi service, Pune shirdi darshan taxi car rental, pune to ashtavinayak cab, Pune Darshan Cab, Pune Darshan Taxi Service, Pune City Tour Cab, Pune Sightseeing Cab, Pune Local Cab Service, Pune Darshan Package Cab, Pune One Day Tour Cab, Pune Tourism Cab Service, Pune Temple Darshan Cab, Pune Heritage Tour Cab, Best Pune Darshan Cab Service, Affordable Pune Darshan Cab, Pune Cab Booking for Sightseeing, Pune Airport to Pune Darshan Cab, Pune darshan cab price, pune darshan service, Pune Darshan Packages"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/1.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punedarshancab;